import React  from 'react';

import PaternalBibliographyContent from "../content/PaternalBibliographyContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function PaternalBibliography() {
    return(
        <>
        <Navbar />
        <PaternalBibliographyContent/>
        <Footer />        
        </>
    );
}

export default PaternalBibliography;